import React from 'react';
import { components } from 'react-select';
import { useStyles } from './ValueContainerWithMultiValuesSliced.styles';
export function ValueContainerWithMultiValuesSliced(props) {
    const classes = useStyles();
    const allValues = props.getValue();
    const remainingItems = allValues.length - props.maxDisplayedSelectedOptions;
    const renderValues = () => {
        if (!props.children) {
            return React.createElement(React.Fragment, null);
        }
        if (Array.isArray(props.children[0])) {
            return props.children[0].slice(0, props.maxDisplayedSelectedOptions);
        }
        return props.children[0];
    };
    const renderInput = () => {
        if (!props.children) {
            return React.createElement(React.Fragment, null);
        }
        return props.children[1];
    };
    const renderRemainingItems = () => React.createElement("div", { className: classes.remainingItems },
        "+ ",
        remainingItems,
        " more");
    return (React.createElement(components.ValueContainer, Object.assign({}, props),
        renderValues(),
        remainingItems >= 1 && renderRemainingItems(),
        renderInput()));
}
//# sourceMappingURL=ValueContainerWithMultiValuesSliced.js.map